var render = function render(){var _vm=this,_c=_vm._self._c;return _c('eden-container',[_c('div',{staticClass:"wallet-banner"},[_c('div',{staticClass:"value text-bold"},[_vm._v(_vm._s(_vm.formatPrice(_vm.balance)))]),_c('div',{staticClass:"information font-sm"},[_vm._v(_vm._s(_vm.name)+"’s Wallet Balance")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }